<i18n>
{
	"en": {
		"newOrder": "New Order",
		"ordersFound": "No orders | {count} order | {count} orders",
		"orderDetails": "Order Details",
		"addToTransporter": "Add to Transporter",
		"noOrdersFound": "No orders were found that match this search. Try expanding your search criteria.",
		"customerName": "Customer",
		"eta": "ETA/ATA",
		"etd": "ETD/ATD",
		"from": "From",
		"loadingMeters": "Loading",
		"numberOfPallets": "Pallets",
		"order": "Order",
		"status": "Status",
		"to": "To",
		"volume": "Volume",
		"waybill": "Waybill",
		"chargableWeight": "Chargable Weight",
		"waybillNumber": "Waybill no.",
		"registeredDate": "Registered Date",
		"numberOfPackages": "Packages",
		"consignee": "Consignee",
		"consignor": "Consignor",
		"accepted": "Accepted",
		"grossWeight": "Gr. Weight",
		"consigneeReference": "Consignee Ref",
		"customersReference": "Customers Ref",
		"internalNotes": "Internal Notes",
		"poReference": "PO Ref",
		"sendersReference": "Senders Ref",
		"transporterInstructions": "Transporter Instructions",
		"yes": "Yes",
		"no": "No",
		"fullyPlanned": "Fully Planned",
		"hasExternal": "Has External",
		"economicalStatus": "Economical Status",
		"despatchParty": "Despatch Party",
		"deliveryParty": "Delivery Party",
		"packageLabel": "Labels",
		"cancelled": "Cancelled",
		"incomplete": "Incomplete",
		"invoiced": "Invoiced",
		"notSettled": "Not Settled",
		"recorded": "Recorded",
		"settled": "Settled",
		"orderType": "Order Type",
		"geocode": "Geocode",
		"failedToGeocode": "Failed to geocode the selected orders",
		"editOrder": "Edit Order",
		"editOrderJson": "Edit JSON",
		"geocodeOrder": "Geocode Order",
		"status/cancelled": "Cancelled",
		"status/draft": "Draft",
		"status/ready": "Ready",
		"status/planned": "Planned",
		"status/rejected": "Rejected",
		"status/unsuccessful": "Unsuccessful",
		"status/requested": "Requested",
		"status/received": "Received",
		"status/accepted": "Accepted",
		"status/readyForPickup": "Ready for Pickup",
		"status/loaded": "Loaded",
		"status/unloaded": "Unloaded"
	},
	"no": {
		"newOrder": "Nytt oppdrag",
		"ordersFound": "Ingen oppdrag | {count} tilgjengelig oppdrag | {count} oppdrag",
		"orderDetails": "Detaljer Oppdrag",
		"addToTransporter": "Ekstern leverandør",
		"noOrdersFound": "Vi fant ingen oppdrag som matcher dette søket. Prøv å utvide søkekriteriene.",
		"customerName": "Kunde",
		"eta": "ETA/ATA",
		"etd": "ETD/ATD",
		"from": "Fra",
		"loadingMeters": "Lastm.",
		"numberOfPallets": "Paller",
		"order": "Oppdrag",
		"status": "Status",
		"to": "Til",
		"volume": "Vol",
		"waybill": "Fraktbrev",
		"waybillNumber": "Fraktbrevnr",
		"chargableWeight": "Fraktberegningsvekt",
		"registeredDate": "Registrert dato",
		"numberOfPackages": "Kolli",
		"consignee": "Mottaker",
		"consignor": "Avsender",
		"accepted": "Akseptert",
		"grossWeight": "Br. vekt",
		"consigneeReference": "Mottaker Ref",
		"customersReference": "Kunde Ref",
		"internalNotes": "Interne notater",
		"poReference": "PO ref",
		"sendersReference": "Avsender ref",
		"transporterInstructions": "Transportør instruksjoner",
		"yes": "Ja",
		"no": "Nei",
		"fullyPlanned": "Ferdig planlagt",
		"hasExternal": "Har ekstern",
		"economicalStatus": "Økonomisk status",
		"despatchParty": "Henteaddresse",
		"deliveryParty": "Leveringsaddresse",
		"packageLabel": "Etiketter",
		"cancelled": "Annullert",
		"incomplete": "Ufullstendig",
		"invoiced": "Oppgjort",
		"notSettled": "Ikke klarert",
		"recorded": "Bokført",
		"settled": "Klarert",
		"orderType": "Oppdragstype",
		"geocode": "Geokode",
		"failedToGeocode": "Kunne ikke geokode oppdrag",
		"editOrder": "Rediger oppdrag",
		"editOrderJson": "Rediger JSON",
		"geocodeOrder": "Geokode oppdrag",
		"status/cancelled": "Annullert",
		"status/draft": "Kladd",
		"status/ready": "Klar",
		"status/planned": "Planlagt",
		"status/rejected": "Avslått",
		"status/unsuccessful": "Bomtur",
		"status/requested": "Forespurt",
		"status/received": "Mottatt",
		"status/accepted": "Akseptert",
		"status/readyForPickup": "Klar for henting",
		"status/loaded": "Lastet",
		"status/unloaded": "Losset"
	}
}
</i18n>
<template>
	<t-vertical-panel :hideSubHeader="!ordersFound" class="order-list">
		<div slot="header" class="order-list-header">
			<t-panel-header size="md" icon="orders" class="order-list-panel-header">
				{{ $tc('ordersFound', !ordersLoading && ordersFetching ? totals.orders : ordersFound) }}
			</t-panel-header>
			<div class="order-list-summary">
				<t-metric-details
					:value="displayedVolume"
					decimals="1"
					hide-pie-icon
					unit="m3"
				/>
				<t-metric-details
					:value="displayedWeight"
					hide-pie-icon
					unit="kg"
				/>
				<t-metric-details
					:value="displayedLoadingMeters"
					decimals="1"
					hide-pie-icon
					unit="lm"
				/>
				<t-metric-details
					:value="displayedTotalPrice"
					decimals="2"
					hide-pie-icon
					:unit="totals.baseCurrency"
				/>
			</div>
		</div>
		<div slot="sub-header" class="order-list-sub-header">
			<t-button
				:value="$t('orderDetails')"
				:disabled="!singleOrderSelected"
				appearance="minimal"
				type="bp"
				iconBefore="application"
				@click="showDetails()"
			/>
			<t-button
				:value="$t('geocode')"
				:disabled="rowsSelected === 0"
				:busy="geocoding"
				appearance="minimal"
				type="bp"
				iconBefore="locate"
				@click="onGeocodeAddresses"
			/>
			<div />
			<t-button
				:value="$t('packageLabel')"
				:disabled="rowsSelected === 0"
				appearance="minimal"
				type="timpex"
				iconBefore="package-label"
				@click="showPackageLabel"
			/>
			<t-button
				:value="$t('waybill')"
				:disabled="rowsSelected === 0"
				appearance="minimal"
				type="timpex"
				iconBefore="waybill"
				@click="showWaybill"
			/>
		</div>

		<div class="order-list-content">
			<!-- Key disables grid component reuse. Fixes localStorageId changing between views. -->
			<t-grid
				v-if="ordersFound"
				ref="grid"
				:key="localStorageId"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="50"
				:items="orders"
				:localStorageId="localStorageId"
				selectable
				@selected="onRowsSelected"
				@rowDoubleClick="setEditOrder"
				@enter="showDetails()"
				@filtered="onFiltered"
			>
				<template v-slot:status="{ item }">
					<t-timpex-icon
						:icon="getStatusIcon(item)"
						:color="getStatusColor(item)"
						:title="getStatusTitle(item)"
						size="md"
						style="padding-left: 3px;"
					/>
				</template>
				<template v-slot:from="{ displayValue }">
					<div v-if="displayValue" style="height: 16px;">{{ displayValue.name }}</div>
					<div v-if="displayValue" class="grid-cell-sub-line" :class="{'missing-geo-data': !displayValue.latitude || !displayValue.longitude }">{{ displayValue.street }}, {{ displayValue.postalCode }} {{ displayValue.postalPlace }}</div>
				</template>
				<template v-slot:to="{ displayValue }">
					<div v-if="displayValue" style="height: 16px;">{{ displayValue.name }}</div>
					<div v-if="displayValue" class="grid-cell-sub-line" :class="{'missing-geo-data': !displayValue.latitude || !displayValue.longitude }">{{ displayValue.street }}, {{ displayValue.postalCode }} {{ displayValue.postalPlace }}</div>
				</template>
				<template v-slot:despatchParty="{ item }">
					<div v-if="item.despatchParty" style="height: 16px;">{{ item.despatchParty.name }}</div>
					<div v-if="item.despatchParty" class="grid-cell-sub-line" :class="{'missing-geo-data': !item.despatchParty.latitude || !item.despatchParty.longitude }">{{ item.despatchParty.street }}, {{ item.despatchParty.postalCode }} {{ item.despatchParty.postalPlace }}</div>
				</template>
				<template v-slot:deliveryParty="{ item }">
					<div v-if="item.deliveryParty" style="height: 16px;">{{ item.deliveryParty.name }}</div>
					<div v-if="item.deliveryParty" class="grid-cell-sub-line" :class="{'missing-geo-data': !item.deliveryParty.latitude || !item.deliveryParty.longitude }">{{ item.deliveryParty.street }}, {{ item.deliveryParty.postalCode }} {{ item.deliveryParty.postalPlace }}</div>
				</template>
				<template v-slot:consignee="{ item }">
					<div v-if="item.consignee" style="height: 16px;">{{ item.consignee.name }}</div>
					<div v-if="item.consignee" class="grid-cell-sub-line">{{ item.consignee.street }}, {{ item.consignee.postalCode }} {{ item.consignee.postalPlace }}</div>
				</template>
				<template v-slot:consignor="{ item }">
					<div v-if="item.consignor" style="height: 16px;">{{ item.consignor.name }}</div>
					<div v-if="item.consignor" class="grid-cell-sub-line">{{ item.consignor.street }}, {{ item.consignor.postalCode }} {{ item.consignor.postalPlace }}</div>
				</template>
				<template v-slot:customer="{ item }">
					<div v-if="item.customer" style="height: 16px;">{{ item.customer.name }}</div>
					<div v-if="item.customer" class="grid-cell-sub-line">{{ item.customer.customerNo }}</div>
				</template>
				<template v-slot:contextMenu="{ item }">
					<t-menu>
						<t-menu-group>
							<t-menu-item icon="edit" @click="setEditOrder(item.id)"><strong>{{$t('editOrder')}}</strong></t-menu-item>
							<t-menu-item icon="application" @click="showDetails(item.id)">{{$t('orderDetails')}}</t-menu-item>
							<t-menu-item icon="locate" @click="geocodeSingleOrder(item.id)">{{$t('geocodeOrder')}}</t-menu-item>
							<hr>
							<t-menu-item icon="package-label" @click="showSinglePackageLabel(item.id)">{{$t('packageLabel')}}</t-menu-item>
							<t-menu-item icon="waybill" @click="showSingleWaybill(item.id)">{{$t('waybill')}}</t-menu-item>
							<template v-if="isTimpexSupport">
								<hr>
								<t-menu-item icon="edit" @click="showOrderJson(item.id)">{{$t('editOrderJson')}}</t-menu-item>
							</template>
						</t-menu-group>
					</t-menu>
				</template>
			</t-grid>

			<t-no-content-panel v-else :text="$t('noOrdersFound')" icon="order" />
			<t-overlay
				:isShown="ordersLoading"
				loaderMarginBottom="50px"
				absolute
				loader
			/>
		</div>
	</t-vertical-panel>
</template>

<script>
import { mapDynamicState, mapDynamicActions } from '@/core/mapDynamic';
import { mapGetters as mapLoginGetters } from '../login/store/login.store';
import Grid from '@/components/evergreen/timpex/grid/TGrid';
import {
	displayDateFormat, storageDateFormat, displayDateFormatter, dateExists, goodsTypesIcons, statuses, sumValues, eventBus
} from '@/core';
import moment from 'moment';
import OrderStatusFilter from './OrderStatusFilter';
import TMetricDetails from '@/components/evergreen/timpex/layers/TMetricDetails';

export default {
	name: 'OrderList',
	components: { TMetricDetails, TGrid: Grid, },
	data() {
		return {
			defaultColumnDefinition: {
				resizable: true,
				headerFilterInputWithButton: true,
			},
			rowsSelected: 0,
			filteredGridOrderIds: []
		};
	},
	computed: {
		...mapDynamicState('computedStoreNamespace', [
			'orders',
			'ordersLoading',
			'geocoding',
			'ordersFetching',
			'totals'
		]),
		...mapLoginGetters(['isTimpexSupport']),
		ordersFound() {
			return this.filteredOrders.length;
		},
		singleOrderSelected() {
			return this.rowsSelected === 1;
		},
		searchId() {
			return this.$route.params.searchId || -1;
		},
		localStorageId() {
			return `orderSearchList/${this.searchId}`;
		},
		computedStoreNamespace() {
			return `orderSearch/${this.searchId}`;
		},
		selectedOrders() {
			return this.$refs.grid.getSelectedItems() || [];
		},
		filteredOrders() {
			if (!this.filteredGridOrderIds || this.filteredGridOrderIds.length === 0) return this.orders;
			let lookup = new Set (this.filteredGridOrderIds);
			return this.orders.filter(x => lookup.has(x.id));
		},
		totalVolume() {
			return this.ordersFetching ? this.totals.volume : sumValues(this.filteredOrders, 'volume');
		},
		totalWeight() {
			return this.ordersFetching ? this.totals.weight : sumValues(this.filteredOrders, 'grossWeight');
		},
		totalLoadingMeters() {
			return this.ordersFetching ? this.totals.loadingMeters : sumValues(this.filteredOrders, 'loadingMeters');
		},
		totalPrice() {
			return this.ordersFetching ? this.totals.totalPrice : sumValues(this.filteredOrders, 'totalPrice');
		},
		displayedVolume() {
			return this.rowsSelected > 0 ? sumValues(this.selectedOrders, 'volume') : this.totalVolume;
		},
		displayedWeight() {
			return this.rowsSelected > 0 ? sumValues(this.selectedOrders, 'grossWeight') : this.totalWeight;
		},
		displayedLoadingMeters() {
			return this.rowsSelected > 0 ? sumValues(this.selectedOrders, 'loadingMeters') : this.totalLoadingMeters;
		},
		displayedTotalPrice() {
			return this.rowsSelected > 0 ? sumValues(this.selectedOrders, 'totalPrice') : this.totalPrice;
		},
		columnDefinitions() {
			return [
				{
					field: 'status',
					displayName: this.$t('status'),
					valueGetter: item => item.name,
					width: 50,
					resizable: false,
					customFilterComponent: OrderStatusFilter,
					headerFilterButtonOnly: true,
				},
				{
					field: 'etd.date',
					displayName: this.$t('etd'),
					valueGetter: item => displayDateFormatter(this.dateGetter(item.atd, item.etd)),
					width: 90,
					resizable: false,
					type: 'date',
					dateFormat: displayDateFormat,
					comparableValueGetter: item => moment(this.dateGetter(item.atd, item.etd), storageDateFormat).startOf('day').toISOString(),
					cellClass(item) { return dateExists(item.atd) ? 'grid-cell-bold' : 'grid-cell-light'; }
				},
				{
					field: 'from',
					displayName: this.$t('from'),
					valueGetter: item => item.despatchParty || item.consignor,
					comparableValueGetter: item => this.addressGetter(item.despatchParty || item.consignor),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'to',
					displayName: this.$t('to'),
					valueGetter: item => item.deliveryParty || item.consignee,
					comparableValueGetter: item => this.addressGetter(item.deliveryParty || item.consignee),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'eta.date',
					displayName: this.$t('eta'),
					valueGetter: item => displayDateFormatter(this.dateGetter(item.ata, item.eta)),
					width: 90,
					resizable: false,
					type: 'date',
					dateFormat: displayDateFormat,
					comparableValueGetter: item => moment(this.dateGetter(item.ata, item.eta), storageDateFormat).startOf('day').toISOString(),
					cellClass(item) { return dateExists(item.ata) ? 'grid-cell-bold' : 'grid-cell-light'; }
				},
				{
					field: 'customer',
					displayName: this.$t('customerName'),
					comparableValueGetter: ({ customer }) => customer ? `${customer.name} ${customer.customerNo}` : '',
					minWidth: 125,
					type: 'customer',
				},
				{
					field: 'orderNumber',
					displayName: this.$t('order'),
					width: 90,
					resizable: false,
					type: 'number',
					sortDirection: 'desc',
					comparableValueGetter: (item) => Number(item.orderNumber),
				},
				{
					field: 'orderType',
					displayName: this.$t('orderType'),
					valueGetter: ({ orderType }) => orderType ? orderType.name : '',
					minWidth: 100,
				},
				{
					field: 'numberOfPallets',
					displayName: this.$t('numberOfPallets'),
					valueGetter: ({ numberOfPallets }) => parseInt(numberOfPallets),
					type: 'number',
					width: 60
				},
				{
					field: 'grossWeight',
					displayName: this.$t('grossWeight'),
					type: 'number',
					width: 60
				},
				{
					field: 'loadingMeters',
					displayName: this.$t('loadingMeters'),
					type: 'number',
					width: 60
				},
				{
					field: 'volume',
					displayName: this.$t('volume'),
					type: 'number',
					width: 60
				},
				{
					field: 'chargableWeight',
					displayName: this.$t('chargableWeight'),
					type: 'number',
					width: 60
				},
				{
					field: 'waybillNumber',
					displayName: this.$t('waybillNumber'),
					width: 130,
					resizable: true,
					type: 'number',
				},
				{
					field: 'numberOfPackages',
					displayName: this.$t('numberOfPackages'),
					type: 'number',
					width: 60
				},
				{
					field: 'despatchParty',
					displayName: this.$t('despatchParty'),
					comparableValueGetter: item => this.addressGetter(item.despatchParty),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'deliveryParty',
					displayName: this.$t('deliveryParty'),
					comparableValueGetter: item => this.addressGetter(item.deliveryParty),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'consignee',
					displayName: this.$t('consignee'),
					comparableValueGetter: item => this.addressGetter(item.consignee),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'consignor',
					displayName: this.$t('consignor'),
					comparableValueGetter: item => this.addressGetter(item.consignor),
					type: 'address',
					minWidth: 125,
				},
				{
					field: 'accepted',
					displayName: this.$t('accepted'),
					valueGetter: item => item.accepted ? this.$t('yes') : this.$t('no'),
				},
				{ field: 'consigneeReference', displayName: this.$t('consigneeReference') },
				{ field: 'customersReference', displayName: this.$t('customersReference') },
				{ field: 'internalNotes', displayName: this.$t('internalNotes') },
				{ field: 'poReference', displayName: this.$t('poReference') },
				{ field: 'sendersReference', displayName: this.$t('sendersReference') },
				{
					field: 'transporterInstructions',
					displayName: this.$t('transporterInstructions'),
					minWidth: 125,
				},
				{
					field: 'fullyPlanned',
					displayName: this.$t('fullyPlanned'),
					valueGetter: item => item.fullyPlanned ? this.$t('yes') : this.$t('no'),
				},
				{
					field: 'hasExternal',
					displayName: this.$t('hasExternal'),
					valueGetter: item => item.hasExternal ? this.$t('yes') : this.$t('no'),
				},
				{
					field: 'economicalStatus',
					displayName: this.$t('economicalStatus'),
					valueGetter: item => this.$t(this.getEconomicalStatus(item)),
				}
			];
		},
	},
	methods: {
		...mapDynamicActions('computedStoreNamespace', [
			'setOrderDetails',
			'setOrderJson',
			'getWaybill',
			'getPackageLabel',
			'geocodeOrders'
		]),
		showWaybill() {
			let ids = this.selectedOrders.map(x => x.id);
			this.getWaybill(ids);
		},
		showSingleWaybill(id) {
			this.getWaybill([id]);
		},
		showPackageLabel() {
			let ids = this.selectedOrders.map(x => x.id);
			this.getPackageLabel(ids);
		},
		showSinglePackageLabel(id) {
			this.getPackageLabel([id]);
		},
		addressGetter(party) {
			if (!party) return '';
			return `${party.name} ${party.street} ${party.postalCode} ${party.postalPlace}`;
		},
		showDetails(id) {
			let order = undefined;
			if (id) {
				order = this.orders.find(x => x.id === id);
			} else {
				let selectedItems = this.$refs.grid.getSelectedItems();
				if (selectedItems.length > 1) return;
				[order] = selectedItems;
			}
			if (!order) return;

			this.setOrderDetails(order.id);
			this.$emit('showDetails');
		},
		showOrderJson(id) {
			let order = this.orders.find(x => x.id === id);
			if (!order) return;

			this.setOrderJson(order.id);
			this.$emit('showOrderJson');
		},
		dateGetter(actual, estimated) {
			if (dateExists(actual)) return actual.date;
			if (dateExists(estimated)) return estimated.date;
			return undefined;
		},
		getStatusIcon(item) {
			return goodsTypesIcons(item.goodsType);
		},
		getStatusColor(item) {
			return statuses.color(item.status);
		},
		getEconomicalStatus(item) {
			return statuses.economical(item.economicalStatus);
		},
		getStatusTitle(item) {
			return this.$t(`status/${statuses.operational(item.status)}`);
		},
		onRowsSelected(ids) {
			this.rowsSelected = ids.length;
		},
		async onGeocodeAddresses() {
			try {
				await this.geocodeOrders(this.selectedOrders.map(x => ({ id: x.id })));
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToGeocode')
				});
			}
		},
		async geocodeSingleOrder(id) {
			try {
				await this.geocodeOrders([{ id }]);
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToGeocode')
				});
			}
		},
		setEditOrder(id) {
			let order = this.orders.find(x => x.id === id);
			if (!order) return;
			eventBus.$emit('setEditOrder', order.id);
		},
		onFiltered(ids) {
			this.filteredGridOrderIds = ids;
		},
	},
};
</script>


<style lang="scss" scoped>
.order-list {
	.order-list-header {
		height: 100%;
		display:flex;
		align-items: center;
		padding-left: 15px;
	}
	.order-list-panel-header {
		width: 145px;
	}
	.order-list-summary {
		display:grid;
		padding: 15px;
		grid-template-columns: repeat(4, max-content);
		grid-column-gap: 10px;
		margin-right: auto;
		width: 225px;
	}
	.order-list-sub-header {
		display:grid;
		padding: 0px 15px;
		height: 100%;
		align-items: center;
		grid-template-columns: repeat(2, minmax(100px, max-content)) auto repeat(2, minmax(100px, max-content));
		grid-column-gap: 10px;
	}
	.order-list-content {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 5px
	}
}
</style>
